import { CreditsBalance } from "shared/utils/credits"
import { creditLabel } from "./utils/credits"

import styles from "./credit_summary.module.scss"

interface Props {
  balance: CreditsBalance
}

const CreditSummary = ({ balance }: Props) => (
  <div className={styles["credit-summary"]}>
    <span className={styles.remaining}>{creditLabel(balance.remaining)} remaining</span>
  </div>
)

export default CreditSummary
